"use client";

import dynamic from "next/dynamic";

/**
 * Wrap a recharts-bearing client component in `next/dynamic({ ssr: false })`
 * so it ships in its own async chunk instead of joining the static page
 * bundle. Recharts is ~84 KiB gz; without this, Link-prefetch from a
 * sibling route that doesn't render the chart still drags the lib in.
 *
 * Pass `height` matching the impl's `ResponsiveContainer` so the loading
 * placeholder reserves the right vertical space and the surrounding
 * layout doesn't jump on chunk arrival. sc-26761 / sc-26772.
 *
 * The generic `C` lets TypeScript infer the impl's exact type from the
 * loader, preserving generic component signatures (e.g. `Treemap<M>`)
 * that a `ComponentType<P>` return type would collapse. The callable
 * constraint blocks loaders that resolve to non-component values from
 * compiling — without it, a typo'd `.then((m) => m.SomeType)` would
 * only fail at render time.
 */
export function dynamicChart<C extends (...args: never[]) => unknown>(
  loader: () => Promise<C>,
  height: number,
): C {
  return dynamic(loader as never, {
    ssr: false,
    loading: () => <div style={{ height }} aria-hidden />,
  }) as unknown as C;
}
